import React from "react";
import { Link } from "react-router-dom";
import "./authenticate.css"; // Importing the CSS file for styling

function AuthType() {
  return (
    <div className="authType">
      <div className="head">
        <h1>
          Welcome to Parking Management System <br />
          (PMS)
        </h1>
      </div>
      <Link to="/adminLogin">
        <button className="authButton">Admin Login</button>
      </Link>
      <Link to="/userLogin">
        <button className="authButton mt-3">User Login</button>
      </Link>
    </div>
  );
}

export default AuthType;
